export default __webpack_public_path__ + "static/media/mainCartImg.7fd659e7.png";